import { TableColumn } from '../../../components/DataTable/TableColumn';
import { TextColumn } from '../../../components/DataTable/TextColumn';
import { DateColumn } from '../../../components/DataTable/DateColumn';
import { PazaramaOrder } from '../../../interfaces/Pazarama/PazaramaOrder';
import { PazaramaProductsCell } from './PazaramaProductsCell';
import { PazaramaStatusCell } from './PazaramaStatusCell';
import { Pagination } from '../../../interfaces/Pagination';
import { DataTable } from '../../../components/DataTable/DataTable';

const columns: TableColumn<PazaramaOrder>[] = [
  {
    id: 'pazarama-id',
    name: 'Pazarama ID',
    accessor: (row) => <TextColumn value={row.pazaramaID} />,
  },
  {
    id: 'products',
    name: 'Ürünler',
    accessor: (row) => <PazaramaProductsCell order={row} />,
  },
  {
    id: 'status',
    name: 'Durum',
    align: 'center',
    accessor: (row) => <PazaramaStatusCell status={row.status} />,
  },
  {
    id: 'created-at',
    name: 'Sipariş Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
];

type PazaramaOrdersTableProps = {
  orders: PazaramaOrder[];
  totalCount: number;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
};

export const PazaramaOrdersTable = (props: PazaramaOrdersTableProps) => {
  return (
    <DataTable
      columns={columns}
      totalCount={props.totalCount}
      rows={props.orders}
      limit={props.pagination.pageSize}
      setLimit={(newLimit) =>
        props.onPagination({ page: 0, pageSize: newLimit })
      }
      page={props.pagination.page}
      setPage={(newPage) =>
        props.onPagination({ ...props.pagination, page: newPage })
      }
    />
  );
};
